import React from "react"
import Obfuscate from "react-obfuscate"
import { useBuildData } from "../../hooks/use-build-data"

const MaintenancePage = () => {
  const data = useBuildData()
  return (
    <section
      style={{
        width: "100%",
        maxWidth: "600px",
        backgroundColor: "transparent",
        border: "2px solid",
        borderRadius: "0.5rem",
        padding: "2rem",
        textAlign: "center",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        margin: "10% auto",
      }}
    >
      <h1
        style={{
          fontSize: "1.5rem",
          marginBottom: "1rem",
        }}
      >
        Services temporairement indisponibles
      </h1>

      <p style={{ fontSize: "1rem", margin: "0.5rem 0" }}>
        Les services de prise de rendez-vous et le formulaire de contact sont
        momentanément indisponibles.
      </p>

      <p style={{ fontSize: "1rem", margin: "0.5rem 0" }}>
        Vous pouvez nous joindre par téléphone ou par e-mail :
      </p>

      <div style={{ marginTop: "1.5rem" }}>
        <p style={{ fontSize: "1rem", margin: "0.5rem 0" }}>
          <strong>Téléphone :</strong>{" "}
          <Obfuscate tel={data.mentions_settings.phone_number} />
        </p>
        <p style={{ fontSize: "1rem", margin: "0.5rem 0" }}>
          <strong>Adresse électronique :</strong>{" "}
          <Obfuscate email={data.mentions_settings.mail_adress} />
        </p>
      </div>
    </section>
  )
}

export { MaintenancePage }
